module.exports = __webpack_public_path__ + "img/L1070082.890838e6.jpg";